"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorageKey = void 0;
const storage_constants_1 = require("../constants/storage.constants");
const getStorageKey = (options) => {
    return options.storageKey ? String(options.storageKey) : storage_constants_1.STORAGE_KEY;
};
exports.getStorageKey = getStorageKey;
